import React from 'react';
import { motion } from 'framer-motion';
import { Shield, Lock, CreditCard, ArrowRight } from 'lucide-react';
export function Hero() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const badges = [{
    icon: '⚡',
    text: 'Acceso Inmediato'
  }, {
    icon: '🇦🇷',
    text: 'Hecho para Argentina'
  }, {
    icon: '🔒',
    text: 'Pago Seguro'
  }];
  return <section className="relative bg-[#14301f] text-[#f5efe1] overflow-hidden pt-16 pb-20 lg:pt-24 lg:pb-28" data-id="element-121">
      {/* earthy ambient glows */}
      <div className="absolute inset-0 z-0 overflow-hidden" data-id="element-122">
        <div className="absolute top-[8%] left-1/2 -translate-x-1/2 w-[120%] h-[70%] rounded-full bg-[#2f6b47]/30 blur-[120px]" data-id="element-123"></div>
        <div className="absolute -bottom-1/4 left-1/2 -translate-x-1/2 w-[80%] h-[60%] rounded-full bg-[#c8971b]/15 blur-[110px]" data-id="element-124"></div>
      </div>
      {/* subtle strata lines */}
      <div className="absolute inset-x-0 bottom-0 h-24 z-0 opacity-40 bg-[repeating-linear-gradient(180deg,transparent,transparent_10px,rgba(111,78,46,0.35)_10px,rgba(111,78,46,0.35)_12px)]" data-id="element-125"></div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-126">
        <div className="max-w-4xl mx-auto text-center" data-id="element-127">
          <motion.div initial={{
          opacity: 0,
          y: -10
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5
        }} className="inline-flex gap-2 text-[#e7c766] font-bold tracking-widest items-center justify-center mb-6 font-[Merriweather,_serif] text-sm" data-id="element-128">
            🌿 MEGAPACK GESTIÓN AMBIENTAL LISTO™
          </motion.div>

          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="text-3xl sm:text-5xl md:text-6xl lg:text-7xl font-black tracking-tight mb-6 text-[#f5efe1] text-balance font-[Merriweather,_serif]" data-id="element-129">
            Del Aula a la Transformación.
            <span className="block text-[#e7c766]" data-id="element-130">Todo Resuelto.</span>
          </motion.h1>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.3
        }} className="text-base md:text-xl font-medium text-[#d8d0bd] mb-10 text-balance max-w-2xl mx-auto" data-id="element-131">
            Sistema completo de conocimiento y recursos para docentes de Gestión
            Ambiental argentina.
          </motion.p>

          {/* Product mockup */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.7,
          delay: 0.35
        }} className="relative max-w-[340px] sm:max-w-[460px] md:max-w-2xl mx-auto mb-10" data-id="element-132">
            <img src="https://cdn.magicpatterns.com/uploads/3S8nBEPmPTPfZTTwyZtGYf/MOCKUP.png" alt="MEGAPACK GESTIÓN AMBIENTAL LISTO" className="w-full h-auto drop-shadow-[0_25px_60px_rgba(0,0,0,0.55)]" data-id="element-133" />
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} className="flex flex-wrap justify-center mb-8 gap-2" data-id="element-134">
            {badges.map((badge, i) => <span key={i} className="inline-flex items-center gap-1.5 px-4 py-2 rounded-full bg-[#1e4230]/80 border border-[#2f6b47]/60 font-semibold backdrop-blur-sm text-[12px] text-[#e6dcc6]" data-id="element-135">
                <span data-id="element-136">{badge.icon}</span> {badge.text}
              </span>)}
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.3
        }} className="mb-10" data-id="element-137">
            <button onClick={scrollToPricing} className="inline-flex items-center justify-center gap-2 px-8 md:px-10 py-4 md:py-5 rounded-2xl bg-[#c8971b] hover:bg-[#b0850f] text-[#14301f] font-black uppercase tracking-wide shadow-[0_10px_40px_-10px_rgba(200,151,27,0.6)] hover:shadow-[0_15px_50px_-10px_rgba(200,151,27,0.8)] transition-all hover:-translate-y-1 text-sm md:text-base" data-id="element-138">
              🔥 QUIERO MI MEGAPACK AHORA
              <ArrowRight className="w-5 h-5" data-id="element-139" />
            </button>
          </motion.div>

          <motion.div initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.4
        }} className="flex flex-wrap justify-center items-center gap-x-6 gap-y-3 text-sm text-[#a9b8ab] font-medium" data-id="element-140">
            <div className="flex items-center gap-1.5" data-id="element-141">
              <Shield className="w-4 h-4 text-[#e7c766]" data-id="element-142" />
              <span data-id="element-143">Garantía 7 días</span>
            </div>
            <div className="flex items-center gap-1.5" data-id="element-144">
              <Lock className="w-4 h-4 text-[#e7c766]" data-id="element-145" />
              <span data-id="element-146">Pago seguro</span>
            </div>
            <div className="flex items-center gap-1.5" data-id="element-147">
              <CreditCard className="w-4 h-4 text-[#e7c766]" data-id="element-148" />
              <span data-id="element-149">Mercado Pago</span>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}